module.exports = __webpack_public_path__ + "static/media/azienda.be0b8af5.jpg";